import FormInput from './FormInput';

export * from './FormInput';
export default FormInput;
